<template>
    <div class="pages sceneMarketing">
        <div class="f2">
            <p class="tit">
                <img src="../../assets/images/newIcon/scenrio_title_icon.png" alt="">
                基础场景
            </p>
            <ul>
                <li>
                    <p><span>生日营销</span></p>
                    <p>会员生日专属营销活动，提升顾客粘性</p>
                    <p><el-button  round @click="newPlan">立即新建</el-button></p>
                </li>
                <li>
                    <p><span>会员日营销</span></p>
                    <p>特定时间内会员专属优惠，提升顾客粘性</p>
                     <p><el-button @click="newPlan" round>立即新建</el-button></p>
                </li>
                <li>
                    <p><span>促销活动</span></p>
                    <p>特定触消活动优惠，刺激用户转化付费</p>
                    <p><el-button @click="newPlan" round>立即新建</el-button></p>
                </li>
                <li>
                    <p><span>其他活动</span></p>
                    <p>根据系统规则自定义创建场景营销，实现数字化经营</p>
                    <p><el-button @click="newPlan" round>立即新建</el-button></p>
                </li>
            </ul>
        </div>
        <div class="f2 mb-30">
            <p class="tit">
                <img src="../../assets/images/newIcon/scenrio_use_icon.png" alt="">
                用户场景
            </p>
            <ul>
                <li>
                    <p><span>用户首次注册</span></p>
                    <p>新用户注册后自动触发的营销活动，提升新客留存</p>
                    <p><el-button @click="newPlan"  round>立即新建</el-button></p>
                </li>
                <li>
                    <p><span>用户首次下单</span></p>
                    <p>用户首次付费后触发的营销活动，吸引顾客复购</p>
                    <p><el-button  @click="newPlan" round>立即新建</el-button></p>
                </li>
                <li>
                    <p><span>用户领券</span></p>
                    <p>用户首次获得优惠券后触发的营销活动，推动用户使用优惠券</p>
                    <p><el-button @click="newPlan" round>立即新建</el-button></p>
                </li>
            </ul>
        </div>
        <div class="f4 bf">
            <div class="d1">
                <p>
                    <span>业务系统：</span>
                    <el-select class="iptRdio" v-model="value" placeholder="请选择业务渠道">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </p>
                <p>
                    <!-- <el-button @click="showPopup(3)" plain class="kh-btn"><img src="../../assets/images/newIcon/label_customer_icon.png" alt=""> 导出</el-button> -->
                    <el-button @click="newPlan" style="background:#327EFF;" type="primary" round><img src="../../assets/images/newIcon/scenario_add_icon.png" alt=""> 新增营销计划</el-button>
                </p>
            </div>
            <el-table
                :data="tableData3"
                :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                style="width: 100%;"
                :cell-style="{textAlign: 'center',fontSize:'12px'}"
                >
                <el-table-column
                prop="name"
                label="名称"
                show-overflow-tooltip
                >
                </el-table-column>

                <el-table-column
                prop="number"
                label="场景"
                >
                </el-table-column>
                <el-table-column
                prop="xmember"
                label="业务系统"
                
                cell-style="background:red;"
                >
                </el-table-column>
                <el-table-column
                prop="lmember"
                label="类型"
               >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="渠道"
                >
                </el-table-column>
                <el-table-column
                prop="status"
                label="状态"
                >
                </el-table-column>
                <el-table-column
                prop="num"
                label="时间"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="操作"
                width='200'
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="goReport">数据报表</el-button>
                        <el-button @click="goDetail" type="text">详情</el-button>
                        <el-button @click="open" type="text">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 24px;"
            :current-page="query.page_index"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="query.page_size"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    data() {
        return {
             query:JSON.parse(JSON.stringify(QUERY)),
            options: [{
                value: '选项1',
                label: '全部'
                }, {
                value: '选项2',
                label: '小橘帮帮'
                }, {
                value: '选项3',
                label: '颐安中台'
                }, {
                value: '选项4',
                label: '业务系统3'
            }],
            total:100,
            value: '',
            tableData3: [{
                name: '赠送活动',
                number:"内置场景名称/自定义场景",
                xmember:"颐安中台",
                lmember:"单次场景",
                labellv:"短信通知",
                status:"待开始",
                num:'2021	.10.12 18:00'
                },{
                name: '赠送活动',
                number:"内置场景名称/自定义场景",
                xmember:"颐安中台",
                lmember:"长期场景",
                labellv:"短信通知",
                status:"待开始",
                num:'2021	.10.12 18:00'
                },{
                name: '赠送活动',
                number:"内置场景名称/自定义场景",
                xmember:"颐安中台",
                lmember:"单次场景",
                labellv:"短信通知",
                status:"待开始",
                num:'2021	.10.12 18:00'
                },{
                name: '赠送活动',
                number:"内置场景名称/自定义场景",
                xmember:"颐安中台",
                lmember:"单次场景",
                labellv:"短信通知",
                status:"待开始",
                num:'2021	.10.12 18:00'
                },{
                name: '赠送活动',
                number:"内置场景名称/自定义场景",
                xmember:"颐安中台",
                lmember:"单次场景",
                labellv:"短信通知",
                status:"待开始",
                num:'2021	.10.12 18:00'
                },{
                name: '赠送活动',
                number:"内置场景名称/自定义场景",
                xmember:"颐安中台",
                lmember:"单次场景",
                labellv:"短信通知",
                status:"待开始",
                num:'2021	.10.12 18:00'
                },{
                name: '赠送活动',
                number:"内置场景名称/自定义场景",
                xmember:"颐安中台",
                lmember:"单次场景",
                labellv:"短信通知",
                status:"待开始",
                num:'2021	.10.12 18:00'
                },],
            
        }
    },
    methods:{
        open() {
            this.$confirm('是否确认删除', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });
        },
        goReport(){
            this.$router.push({name:"scenarioReport",query:{id:"111"}})
    
        },
        goDetail(){
            this.$router.push({name:"sceneDetails",id:"111"});
        },
        newPlan(){
            this.$router.push({name:"newScenarioPlan"})
        }
    }
}
</script>
<style lang="less" scoped>
    .sceneMarketing{
        .f2{
                .tit{
                    display: flex;
                    padding:15px 0;
                    font-size: 16px;
                    font-weight: 500;
                    color: #333940;
                    img{
                        margin-right:10px;
                        width:17px;
                        height:17px;
                        vertical-align: middle;
                    }
                }
                ul{
                    // display: flex;
                    // justify-content: space-between;
                    li{
                        margin-right:1%;
                        width:24%;
                        display: inline-block;
                        padding:15px 30px;
                        border-radius: 8px;
                        box-sizing: border-box;
                        background: #fff;
                        border-left:9px solid #327EFF;
                        p{
                            .icons{
                                margin-right:10px;
                                display: inline-block;
                                width: 4px;
                                height: 16px;
                                background: #3285F8;
                                border-radius: 3px;
                            }
                            span{
                                display: inline-block;
                                // padding:10px 15px;
                                // background: linear-gradient(124deg, #1AA7F1 0%, #3F76FE 100%, #3F76FE 100%);
                                color:#333;
                                // border-radius: 20px;
                            }
                            &:first-of-type{
                                font-size: 16px;
                                font-weight: 500;
                                color: #333333;
                            }
                            &:nth-child(2){
                               
                                height:40px;
                                padding-top:15px;
                                // padding:10px 0;
                                padding-bottom:10px;
                                //  padding-left:15px;
                                font-size: 12px;
                                font-weight: 400;
                                color: #333;
                            }
                            &:last-child{
                                text-align: right;
                                .el-button{
                                    font-size:12px;
                                    border:1px solid #327EFF;
                                    color:#327EFF;
                                }
                            }
                        }
                    }
                }
        }   
        .f4{
            border-radius: 8px;
            .d1{
                padding:15px;
                /deep/ .iptRdio .el-input__inner{
                    border-radius: 30px;
                    // height:38px;
                    background: #F6F6F6;
                    border:0px;
                }
                p{
                    &:first-child{
                        // margin-left:30px;
                        font-size: 16px;
                        span{
                            font-size: 14px;
                            font-weight: 400;
                            color: #676D73;
                        }
                    }
                }
                display: flex;
                justify-content: space-between;
                img{
                    width:16px;
                    height:16px;
                    vertical-align: middle;
                }
                .kh-btn.el-button{
                    border-radius: 15px;
                    border: 1px solid #327EFF;
                    color:#327EFF;
                }
            }
            /deep/ .el-checkbox__inner{
                border-radius: 15px;
            }
            .labelLi{
                display: flex;
                align-items: center;
                justify-content: center;
                p{
                    margin-right:8px;
                    display: inline-block;
                    width:40px;
                    padding:0px 8px;
                    background: rgba(211, 236, 255, 0.4);
                    border-radius: 15px;
                    border: 1px solid rgba(0, 145, 255, 0.11);
                    font-size: 12px;
                    font-weight: 400;
                    color: #0091FF;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    // &:last-child{
                    //     padding:0 4px;
                    //     text-align: center;
                    //     // border:0;
                    //     // background:#fff;
                    // }
                    
                }
                .s{
                    background: rgba(211, 236, 255, 0.4);
                    border: 1px solid rgba(0, 145, 255, 0.11);
                    padding: 2px 10px;
                    color: #0091FF;
                    border-radius: 18px;
                    width: auto;
                }
            }
        } 
    }
</style>